import { Link } from "react-router-dom";

export default function HangoutHighlightsSection() {
    return(
        <section className="p-4 py-12 bg-secondary text-black">
          <div className="container flex flex-col items-center gap-6 mx-auto md:flex-row max-w-7xl">
            <div className="flex flex-col items-center md:items-start text-center md:w-[40%] md:text-left">
              <h2 className="gap-4 font-bold text-[clamp(2rem,1.714rem+1.429vw,3rem)] text-primary">
                Different types of people in TECH SPACE Community Hangout
              </h2>
              
              <Link
                to="#"
                className="w-full py-3 leading-none rounded-full bg-primary text-secondary hover:opacity-90 sm:w-fit sm:px-10"
              >
                View More
              </Link>
            </div>

            <div className="md:w-[60%]">
              <video
                loop
                autoPlay
                controls
                playsInline
                muted
                className="rounded-2xl aspect-video w-full h-auto"
              >
                <source src="/videos/17376469026620 (2).mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </div>
        </section>
    )
}